import gql from 'graphql-tag';
////////////////////////////////////////////////////////////////////////////////
// Mutations
/**
 *  Clear all filters by running their 'clear' mutations
 */
export const clearAllFilters = (_, __, { client, cache }) => {
    const activeFiltersQuery = gql `
    query GetActiveFilters {
      activeFilters @client {
        listFilters {
          id
        }
        rangeFilters {
          id
        }
        booleanFilters {
          id
        }
        multiListFilters {
          id
        }
      }
    }
  `;
    const { activeFilters } = cache.readQuery({
        query: activeFiltersQuery
    });
    activeFilters.listFilters.forEach(listFilter => {
        client.mutate({
            mutation: gql `
        mutation ClearListFilter($id: String!) {
          clearListFilter(id: $id) @client
        }
      `,
            variables: {
                id: listFilter.id
            }
        });
    });
    activeFilters.rangeFilters.forEach(rangeFilter => {
        client.mutate({
            mutation: gql `
        mutation ClearRangeFilter($id: String!) {
          clearRangeFilter(id: $id) @client
        }
      `,
            variables: {
                id: rangeFilter.id
            }
        });
    });
    activeFilters.booleanFilters.forEach(boolFilter => {
        client.mutate({
            mutation: gql `
        mutation ClearBoolFilter($id: String!) {
          setBoolFilter(id: $id, value: null) @client
        }
      `,
            variables: {
                id: boolFilter.id
            }
        });
    });
    activeFilters.multiListFilters.forEach(multiFilter => {
        client.mutate({
            mutation: gql `
        mutation ClearMultiFilter($id: String!) {
          clearMultiListFilter(id: $id) @client
        }
      `,
            variables: {
                id: multiFilter.id
            }
        });
    });
    return null;
};
//# sourceMappingURL=filters.js.map